import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route } from 'react-router-dom';

import useMobileDetect from 'Hooks/useMobileDetect';

import Hubspot, { HUBSPOT_TACKING_ID } from './tracking/hubspot';
import NewSignupPage from './new-signup-page';
import RedirectToAppStore from './redirect-to-app-store';
import SignupPage from './signup-page';

import '../../../public/css_fonts/font-awesome.min.css';
import '../../../public/css_fonts/MyFontsWebfontsKit.css';
import '../../../public/js/plugins/bootstrap/dist/css/bootstrap.css';
import '../../../public/css/totCustom/totGeneral.less';
import '../../../public/css/totCustom/style.less';

const { searchParams } = new URL(window.location.href);
const useLongSignup = searchParams.get('long_signup') !== null;

const Signup = () => {
	const { isDesktop } = useMobileDetect();
	return (
		<HashRouter>
			<Hubspot applicationId={HUBSPOT_TACKING_ID} />
			<Route exact path="/">
				{!useLongSignup && isDesktop() ? <NewSignupPage /> : <SignupPage />}
			</Route>
			<Route path="/downloadApp" component={RedirectToAppStore} />
		</HashRouter>
	);
};

ReactDOM.render(<Signup />, document.getElementById('totango-signup'));
